import axios from 'axios'

export function fetchSiteLoggingIntervals() {
  return (dispatch, getState) => {
    dispatch({
      type: 'SITE_LOGGING_INTERVALS_FETCH',
      payload: axios('/site_logging_intervals')
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/SiteLoggingIntervalActions.js